// extracted by mini-css-extract-plugin
export default {"footerBar":"ILGt7FtRXvhs1WySZnGQ","footerBar__description":"xcd2fprLOIBvHLIvuz_o","red":"SL4lfFgfY2_cYI8nBWn5","orange":"iIR_tbvG2JQVIiaAn_ki","green":"mLMsA4sfHWNbDyW4CIeR"};